import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as Actions from '../actions/EventManagement';

const getListEventReducer = handleActions({
    [Actions.GetListEventRequested]: (state) => ({
        ...state,
        isFetching: false,
    }),
    [Actions.GetListEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListEventReceiveFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearListEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const detailEventReducver = handleActions({
    [Actions.GetDetailEventRequestd]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetDetailEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetDetailEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetDetailEvent]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const createEventReducer = handleActions({
    [Actions.CreateEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.CreateEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.CreateEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearCreateEvent]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const editEventReducer = handleActions({
    [Actions.EditEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.EditEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.EditEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearEditEvent]: (state) => ({
        ...state,
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const deleteEventReducer = handleActions({
    [Actions.DeleteEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.DeleteEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
        success: true,
    }),
    [Actions.DeletEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        success: false,
    }),
    [Actions.ClearDeleteEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
        success: false,
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
    success: false,
});

const getListCompanyEventReducer = handleActions({
    [Actions.GetListCompanyEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetListCompanyEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetListCompanyEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetListCompanyEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const infoEventReducer = handleActions({
    [Actions.GetInfoEventRequested]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.GetInfoEventReceived]: (state, action) => ({
        ...state,
        isFetching: false,
        data: action.payload,
    }),
    [Actions.GetInfoEventReceivedFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
    }),
    [Actions.ClearGetInfoEvent]: () => ({
        isFetching: false,
        data: {},
        errors: {},
    }),
}, {
    isFetching: false,
    data: {},
    errors: {},
});

const createRoleEventReducer = handleActions({
    [Actions.CreateRoleEventRequest]: (state) => ({
        ...state,
        isFetching: true,
    }),
    [Actions.CreateRoleEventReceived]: (state) => ({
        ...state,
        isFetching: false,
        isSuccess: true,
    }),
    [Actions.CreateRoleEventFailure]: (state, action) => ({
        ...state,
        isFetching: false,
        errors: action.payload.errors,
        isSuccess: false,
    }),
    [Actions.ClearCreateRoleEvent]: () => ({
        isFetching: false,
        errors: {},
        isSuccess: false,
    }),
}, {
    isFetching: false,
    isSuccess: false,
    errors: {},
});

export default combineReducers({
    listEvents: getListEventReducer,
    detailEvent: detailEventReducver,
    createEvent: createEventReducer,
    editEvent: editEventReducer,
    deleteEvent: deleteEventReducer,
    listCompanyEvents: getListCompanyEventReducer,
    infoEvent: infoEventReducer,
    createRoleEvent: createRoleEventReducer,
});
